module.exports = __webpack_public_path__ + "static/media/medal.c1153325.svg";